@if (selectedChannel()) {
<div class="chat-header">
  @if (showBackArrow()) {
  <button mat-icon-button (click)="goBack()">
    <mat-icon class="chat-header__back" svgIcon="back"> </mat-icon>
  </button>
  }

  <div class="chat-header__avatar">
    <messaging-avatar
      [name]="selectedChannel()?.displayName || 'N A'"
      [initialsSize]="2"
      size="45"
      [src]="selectedChannel()?.imageURL"
      [ngStyle]="{ cursor: selectedChannel()?.imageURL ? 'pointer' : 'default' }"
      (click)="imagesService.openPhoto(selectedChannel()?.imageURL ?? '', undefined, false)">
    </messaging-avatar>
  </div>
  <div class="chat-header__main">
    <p class="chat-header__title">
      {{ selectedChannel()?.displayName }}
    </p>
    <div class="chat-header__phone">
      @if( selectedChannel()?.routing?.toLowerCase() === 'sms' || selectedChannel()?.routing?.toLowerCase() === 'whatsapp'){
      <mat-icon
        *hasWorkspaceFeature="[WorkspaceFeatures.showChannelPhoneNumberTypeIconOnChannelHeader]"
        [svgIcon]="channelServiceIcon()"
        [attr.aria-label]="channelServiceIcon()"
        [attr.data-channel-routing]="selectedChannel()?.routing">
      </mat-icon>
      } @if (selectedChannel()?.phoneNumber; as phoneNumber) {
      <p class="chat-header__members" *hasChannelFeature="[ChannelFeatures.showPhone]">
        {{ $safeNavigationMigration(phoneNumber) | phone }}
        @if(!hideInputChat() && !hideEditPhone()){
        <mat-icon
          *hasWorkspaceFeature="[WorkspaceFeatures.canChangePhoneNumber]"
          (click)="editPhoneNumber()"
          class="hide-icon"
          svgIcon="pencil"></mat-icon>
        }
      </p>
      } @if (ownerName()) {
      <ng-container *hasWorkspaceFeature="[WorkspaceFeatures.showOwnerOnChatHeader]">
        <mat-icon class="chat-header__members__support-icon" [svgIcon]="'support_agent'"> </mat-icon>
        <p class="chat-header__members">
          {{ ownerName() }}
          <mat-icon
            *hasWorkspaceFeature="[WorkspaceFeatures.canChangeOwner]"
            [matMenuTriggerFor]="changeOwnerMenu"
            #ownerMenuTrigger="matMenuTrigger"
            svgIcon="pencil"></mat-icon>
        </p>
        <mat-menu #changeOwnerMenu="matMenu">
          <ngx-owner-change (closeDrop)="onCloseOwnerMenu()"> </ngx-owner-change>
        </mat-menu>
        @if (awayOwnerName()) { &nbsp; - &nbsp;
        <p class="chat-header__members">By {{ awayOwnerName() }}</p>

        }
      </ng-container>
      }
    </div>
    @if ( selectedChannel()?.isMember && (selectedChannel()?.type === ChannelType.GROUP || selectedChannel()?.type ===
    ChannelType.SUPPORT || (selectedChannel()?.type === ChannelType.BROADCAST && selectedChannel()?.member?.role ===
    ChannelRoles.ADMIN)) ) {
    <p class="chat-header__members">
      <span>{{ selectedChannel()?.totalMembersCount }} {{ 'NGX-MESSAGING.CHAT.members' | translate }}</span>
    </p>
    }
  </div>
  @if (translaterService.verifyHaveTranslationPermissions) {
  <div class="assistant" [matMenuTriggerFor]="languageMenu" #languageMenuTrigger="matMenuTrigger">
    <mat-icon svgIcon="translate"></mat-icon>
    <p>
      {{ selectedChannel()?.lang || translaterService.dealerLanguge | uppercase }}
    </p>
  </div>

  <mat-menu #languageMenu="matMenu" class="language-menu" [disableClose]="true" (closed)="onLanguageMenuClosed()">
    <ngx-language-selector [menuTrigger]="languageMenuTrigger" (selectLanguage)="onCloseLanguageMenu()">
    </ngx-language-selector>
  </mat-menu>
  } @if (translaterService.verifyCanTranslate) {
  <div
    class="assistant"
    [ngClass]="{ 'assistant-disabled': selectedChannel()?.hideTranslateSetting }"
    (click)="setTranslaterSetting()">
    <mat-icon svgIcon="translate"></mat-icon>
    <p>
      {{
        (selectedChannel()?.hideTranslateSetting
          ? 'NGX-MESSAGING.TRANSLATER.enableAutoTranslate'
          : 'NGX-MESSAGING.TRANSLATER.disableAutoTranslate'
        ) | translate
      }}
    </p>
  </div>
  } @if (selectedChannel()?.type !== ChannelType.BROADCAST && selectedChannel()?.isMember) {
  <button
    type="button"
    class="chat-header__icon-btn"
    *hasWorkspaceFeature="[WorkspaceFeatures.canMakeVideoCalls]"
    (click)="startVideoCall()">
    <mat-icon svgIcon="new_videocall"></mat-icon>
  </button>
  }

  <div class="chat-header__drop-down">
    @if(smartRepliesService.showSmartReplies && selectedChannel()?.hideSmartReplies){
    <button type="button" class="chat-header__icon-btn" [matTooltip]="'Show smart replies'" (click)="showSmartReplies()">
      <mat-icon [svgIcon]="'assistant'"></mat-icon>
    </button>
    }

    <ng-container *hasDealerSettings="DealerSettingName.useBotMode">
      <mat-slide-toggle
        *hasWorkspaceFeature="[WorkspaceFeatures.canUseBotMode]"
        class="example-margin"
        (change)="setBotMode()"
        [(ngModel)]="selectedChannel()!.isBotMode">
        {{ selectedChannel()?.isBotMode ? 'Bot enabled' : 'Bot disabled' }}
      </mat-slide-toggle>
    </ng-container>
    @if(!hideInfoButton()){
    <button
      type="button"
      class="chat-header__icon-btn"
      *hasWorkspaceFeature="[WorkspaceFeatures.canSeeConversationInfo]"
      (click)="toggleSidebar(true)">
      <mat-icon svgIcon="info"></mat-icon>
    </button>
    }
  </div>
</div>
}
